import AbstractBuilder from "@/modules/reader/annotations/builders/AbstractBuilder";
import PlayKaraokeAnnotation from "@/modules/reader/annotations/builders/karaoke/PlayKaraokeAnnotation";

class PlayKaraokeBuilder {

    constructor() {

    }

    static get Builder() {
        class Builder extends AbstractBuilder {

            setBookPath(bookPath) {
                this.bookPath = bookPath;
                return this;
            }

            setAvailableSpeech(availableSpeech) {
                this.availableSpeech = availableSpeech;
                return this;
            }

            /**
             * Get the corresponding karaoke rect width, which must be accurate and
             * it will be compared with the last word increment data of each row when parsing the audio data
             * @param rowsWidth
             * @returns {Builder}
             */
            setKaraokeRowWidth(rowsWidth) {
                this.rowsWidth = rowsWidth
                return this;
            }

            build() {
                return new PlayKaraokeAnnotation(this);
            }
        }
        return Builder;
    }
}

export default PlayKaraokeBuilder